Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// See info on illegal ids:
// https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
var idRegex = /^_|^-|^\./;

function idProp(props, propName, componentName) {
  if (idRegex.test(props[propName])) {
    return new Error(String(componentName) + '.' + String(propName) + ' must not start with "_", "-", or ".".');
  }
  return null;
}

idProp.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error('Required prop `' + String(propName) + '` was not specified in `' + String(componentName) + '`');
  }
  return idProp(props, propName, componentName);
};

var idPropTypes = [_propTypes2['default'].string, idProp];

exports['default'] = (0, _airbnbPropTypes.and)(idPropTypes, 'idProp');


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/idProp.js
// module id = 40
// module chunks = 168707334958949